import * as SecureStore from "expo-secure-store";
import { Platform } from "react-native";

/**
 * Tiny persisted key/value flags (e.g. "celebration already shown") — survives
 * app restarts, unlike component refs. expo-secure-store doesn't work on web,
 * so the PWA falls back to localStorage (same pattern as lib/auth.tsx).
 */
export async function getLocalFlag(key: string): Promise<string | null> {
    if (Platform.OS === "web") {
        return typeof localStorage === "undefined" ? null : localStorage.getItem(key);
    }
    try {
        return await SecureStore.getItemAsync(key);
    } catch {
        return null;
    }
}

export async function setLocalFlag(key: string, value: string): Promise<void> {
    if (Platform.OS === "web") {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem(key, value);
        }
        return;
    }
    try {
        await SecureStore.setItemAsync(key, value);
    } catch {
        // Non-critical — worst case the celebration shows again next session.
    }
}

/** Removes a flag, so a one-shot event can legitimately happen again. */
export async function clearLocalFlag(key: string): Promise<void> {
    if (Platform.OS === "web") {
        if (typeof localStorage !== "undefined") {
            localStorage.removeItem(key);
        }
        return;
    }
    try {
        await SecureStore.deleteItemAsync(key);
    } catch {
        // Non-critical — worst case the celebration stays suppressed.
    }
}
